import React, { useState } from "react";
import "./BillProcessSection.css";

const billSteps = [
  {
    title: "STEP 1: BILL INTRODUCTION",
    titleShort: "BILL INTRODUCTION",
    leftList: [
      "A Bill May Be Introduced In Either House",
      "Most Bills Are Introduced By Ministers",
      "Private Members Can Also Introduce Bills",
    ],
    rightList: [
      "Money Bills Must Start In The House Of Reps",
      "Notice Is Given One Sitting Day Before",
      "Title And Purpose Are Announced",
    ],
  },
  {
    title: "STEP 2: FIRST READING",
    titleShort: "FIRST READING",
    leftList: ["Bill is introduced and read for the first time"],
    rightList: ["No debate takes place at this stage"],
  },
  {
    title: "STEP 3: SECOND READING",
    titleShort: "SECOND READING",
    leftList: ["MP explains purpose of bill"],
    rightList: ["Parliament debates bill’s general principles"],
  },
  {
    title: "STEP 4: COMMITTEE STAGE",
    titleShort: "COMMITTEE STAGE",
    leftList: ["Bill examined in detail"],
    rightList: ["Amendments can be proposed and voted on"],
  },
  {
    title: "STEP 5: THIRD READING",
    titleShort: "THIRD READING",
    leftList: ["Final version of bill is presented"],
    rightList: ["Final vote in the house occurs"],
  },
  {
    title: "STEP 6: SENATE PROCESS",
    titleShort: "SENATE PROCESS",
    leftList: ["Bill moves to the Senate"],
    rightList: ["Steps are repeated in the Senate"],
  },
  {
    title: "STEP 7: ROYAL ASSENT",
    titleShort: "ROYAL ASSENT",
    leftList: ["Governor-General signs the bill"],
    rightList: ["Bill becomes official law after signature"],
  },
  {
    title: "STEP 8: LAW ENACTED",
    titleShort: "LAW ENACTED",
    leftList: ["Bill becomes part of law"],
    rightList: ["Government begins implementation"],
  },
];

const BillProcessSection = () => {
  const [selectedStep, setSelectedStep] = useState(0);

  return (
    <div className="bill-process-section" style={{ marginTop: "2rem" }}>
      {/* Step Selector Bar */}
      <div className="step-bar">
        {billSteps.map((step, index) => (
          <div key={index} className="step-with-line">
            {index !== 0 && <div className="step-line" />}
            <div
              className={`step-circle ${
                selectedStep === index ? "active" : ""
              }`}
              onClick={() => setSelectedStep(index)}
            >
              {index + 1}
            </div>
            <div className="step-label">{step.titleShort || step.title}</div>
          </div>
        ))}
      </div>

      {/* Step Title */}
      <div className="step-title">
        <h3>{billSteps[selectedStep].title}</h3>
      </div>

      {/* Step Descriptions */}
      <div className="step-columns">
        <ul>
          {billSteps[selectedStep].leftList.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
        <ul>
          {billSteps[selectedStep].rightList.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default BillProcessSection;
